import React, { useEffect, useState } from 'react';
import axios from 'axios';
import authHeader from "../services/AuthHeader";
import TableDisplay from './TableDisplay';
import { Button } from 'react-bootstrap';
import EditCandidateModal from './EditCandidateModal';
import ReviewCandidateModal from './ReviewCandidateModal';
import { useHistory } from "react-router-dom";
import { MdEmail, MdReadMore, MdOutlineCheck, MdUpload, MdVisibility, MdThumbDown, MdOutlineVisibility } from "react-icons/md";
import { FaPen } from "react-icons/fa";
import EasyEdit from 'react-easy-edit';

const ManageCandidate = (props) => {
    let history = useHistory();
    const initUser ={
            starId: '',
            firstName: '',
            lastName: '',
            email: ''
        };
    const [displayUsers, setDisplayUsers] = useState([]);
        
    const heading = ["Name on Ballot", "Email", "", "Status", "Review",  ""];
    
    const [modalShow, setModalShow] = useState(false);
    const [modalReviewShow, setModalReviewShow] = useState(false);
    
    const [user, setUser] = useState(initUser);
    
    const [mode, setMode] = useState("");
    const [rerender, setRerender] = useState(false);
    
    const modalHide = ()=>{  
        setModalShow(false);
    }
    
    const showModal = ()=>{
        setModalShow(true)
    }
    
    const modalReviewHide = ()=>{   
        setModalReviewShow(false);
    }
    
    const showReviewModal = ()=>{
        setModalReviewShow(true)
    }

    const saveEmails = (value, id) => {
        let arr = value.split(",").map(function(item) {
            return item.trim();
        });
        arr.forEach(elStarId => {
            axios
                .get(
                    process.env.REACT_APP_API_BASE + 'candidate/'+ elStarId,{ headers: authHeader() }
                )
                .then((res) => {
                    const candidate = {
                        BallotCandidateId: id,
                        StarId: elStarId,
                        CandidateEmail: res.data.candidateEmail,
                        CandidateFirstName: res.data.candidateFirstName,
                        CandidateLastName: res.data.candidateLastName
                    }
                    axios
                    .post(
                      process.env.REACT_APP_API_BASE + 'candidate/',
                      candidate, { headers: authHeader() }
                    )
                    .then((res) => setRerender(true));
                });
        });
    }

    const cancel = () => {console.log("Cancelled")}
        
    /* get candidates and the statuses of their statements */
    useEffect(()=>{
        axios.get(
            process.env.REACT_APP_API_BASE + 'candidate/',{ headers: authHeader() }
          )
        .then(res=>{
            let unitList = res.data.map((val,i)=>{
                let statusIcon = '';
                if (val.candidateEmail !== '' && val.candidateStatus === '') {
                    statusIcon = <MdEmail title='waiting for candidate action' aria-label='Waiting for candidate action'/> 
                } else if (val.candidateStatus === 'e' ){
                    statusIcon = <MdReadMore title='candidate needs to upload' aria-label='Candidate needs to upload'/> 
                } else if (val.candidateStatus === 'u'){
                    statusIcon = <MdUpload title='review required' aria-label='Review required'/> 
                } else if (val.candidateStatus === 'r'){
                    statusIcon = <MdOutlineCheck title='approved' aria-label='Approved'/> 
                } else if (val.candidateStatus === 'x'){
                    statusIcon = <MdThumbDown title='rejected' aria-label='Rejected'/> 
                }
                let emailStatus = '';
                let candidateOptions = ''
                if (val.candidateEmail === '') {
                    emailStatus = <EasyEdit
                    type="text"
                    onSave={(value) =>saveEmails(value,val.ballotCandidateId)}
                    onCancel={cancel}
                    saveButtonLabel="Save"
                    cancelButtonLabel="Cancel"
                    attributes={{
                      name: "input_"+val.ballotCandidateId,
                      id: val.ballotCandidateId,
                      'aria-label': `Star ID for ${val.ballotCandidateName}`,
                    }}
                    instructions="Enter Star ID, separate with a comma if multiple"
                  />
                  candidateOptions = <>
                  <tr key={'candidate_'+i}>
                      <td key={'name'+i} width="40%">{val.ballotCandidateName}</td>
                      <td key={'email'+i} width="39%">{emailStatus}</td>
                      <td key={'edit'+i} width="7%" style={{textAlign:'center'}}>
                      
                      </td>
                      <td key={'status'+i} width="7%" style={{textAlign:'center'}}></td>
                      <td key={'visibility'+i} width="7%" style={{textAlign:'center'}}></td>
               
                  </tr>
                  </>;
                } else {
                    emailStatus = <div>{val.candidateEmail}</div>
                    candidateOptions = <>
                  <tr key={'candidate_'+i}>
                      <td key={'name'+i} width="40%">{val.ballotCandidateName}</td>
                      <td key={'email'+i} width="39%">{emailStatus}</td>
                      <td key={'edit'+i} width="7%" style={{textAlign:'center'}}>
                      <button
                        type='button'
                        className='icon-button'
                        aria-label={`Edit candidate email for ${val.ballotCandidateName}`}
                        onClick={() => {
                            setMode("EDIT");
                            showModal();
                            setUser(val);
                        }}
                        >
                        <FaPen title='edit starid' aria-hidden='true' />
                        </button>
                      </td>
                      <td key={'status'+i} width="7%" style={{textAlign:'center'}}>{statusIcon}</td>
                      <td key={'visibility'+i} width="7%" style={{textAlign:'center'}}>
                        {(val.candidateStatement !== '' && val.candidateImageId !== 0) ? (
                            <button
                                type='button'
                                className='icon-button'
                                aria-label={`Review candidate statement for ${val.ballotCandidateName}`}
                                onClick={() => {
                                    setMode("EDIT");
                                    showReviewModal();
                                    setUser(val);
                                }}
                                >
                                {val.candidateStatus === 'r' 
                                    ? <MdOutlineVisibility title='approved' aria-hidden='true' />
                                    : <MdVisibility title='review' aria-hidden='true' />
                                }
                            </button>
                            ) : ''}
                      </td>
               
                  </tr>
                  </>;
                }

                return(candidateOptions);
            });
            setDisplayUsers(unitList);
            setRerender(false);
        });   
    }, [rerender]);

return  (<>
    <h1 className='h2'>Manage Candidates</h1>
    <TableDisplay tableHeading = {heading} tableData = {displayUsers}/>
    <EditCandidateModal mode = {mode} show = {modalShow} user= {user}
     onHide = {modalHide} setRerender={setRerender}
    />
    <ReviewCandidateModal mode = {mode} show = {modalReviewShow} user= {user}
     onHide = {modalReviewHide} setRerender={setRerender}
    />
    <Button style={{marginLeft: '20px'}} className="btn btn-default" type="button" onClick={() => history.goBack()}>Back</Button>
    <br />   
</>); 
}

export default ManageCandidate;
